module.exports = __webpack_public_path__ + "static/media/evaluate-not-helpful-selected.ead6ef3b.svg";